class featuredCallout extends DrupalBehavior {
  onContent(context) {
    const featuredCalloutTags = document.getElementsByClassName('featured-callout')

    for (var i in featuredCalloutTags) {
      featuredCalloutTags[i].onclick = function() {
        const link = $(this).attr('data-link');
        if (!link) {
          return;
        }
        try {
          const parsed = new URL(link, window.location.origin);
          if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
            window.location.href = parsed.href;
          }
        } catch (e) {
          // malformed URL — ignore
        }
      };
    }
  }
}

DrupalBehavior.register('summit_theme', 'featured_callout', featuredCallout);
